import styled from 'styled-components';
import { toRem } from '../../styles';

export const StyledSkeletonLines = styled.div<{ isMarginTop: boolean }>`
  margin-top: ${({ isMarginTop }) => (isMarginTop ? toRem(10) : '0')};
`;
